import { render } from "./tax-settings.vue?vue&type=template&id=4de8ab6e"
import script from "./tax-settings.vue?vue&type=script&lang=js"
export * from "./tax-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__